<template>
  <div class="datetime">
    <div class="mask" v-if="timeType > 0" @click="setTimeBox(0)"></div>
    <div class="page" :class="{on:timeType > 0,hide:timeType == 0}">
      <div class="btns">
        <div class="btn" @click="setTimeBox(0)">取消</div>
        <div class="btn" @click="confirm">确定</div>
      </div>
      <awesome-picker ref="startPicker" :data="tempDataList" :anchor="curStartValue" @change="onChange"></awesome-picker>
    </div>
  </div>
</template>
<script>
  import {
    getNowFormatDate,
    setYYYYMMdd,
    setYYYY,
    getMonth,
  } from '@/utils/formatDate';
  import awesomePicker from '@/components/datetime/lib/vue-awesome-picker.vue'

  export default {
    name: 'datetimeMini',
    components: {
      awesomePicker
    },
    data: function () {
      return {
        timeType: 0, //0无 1显示
        tempCurTime: "",//当前时间
        tempYearList: [], //选择年份列表
        monthList: [], //选择月份列表
        tempDataList: [],  //组件显示列表
        curStartValue: [0, 0, 0],  //当前选中开始时间：年，月
      }
    },
    props: [
      'start',
      'current',
      'type',
      'onCancel',
      'onConfirm',
    ],
    created() {
      this.timeType = this.type;
      this.tempCurTime = this.current || getNowFormatDate();
    },
    mounted() {
      this.initYear();
      this.initMonth();
      this.setTimeBox(this.timeType);
    },
    watch: {},
    methods: {
      //初始化年份
      initYear() {
        this.tempYearList = [];
        let tempDate = setYYYYMMdd(this.start);
        let maxYear = setYYYY() - setYYYY(tempDate);
        for (let i = 0; i <= maxYear; i++) {
          let obj = {
            date: tempDate,
            year: setYYYY(tempDate)
          };
          this.tempYearList.push(obj);
          tempDate = setYYYYMMdd(tempDate, 1);
        }
      },
      //初始化月份
      initMonth() {
        let currentMonth = 12;
        let index = 1;
        let arr = [];
        if (this.tempCurTime) {
          let currentYear = this.tempYearList[this.curStartValue[0]].year;
          let startMonth = {
            year: setYYYY(this.start),
            month: 12 - getMonth(this.start)
          };
          let endMonth = {
            year: setYYYY(),
            month: getMonth() + 1
          };
          if (currentYear == startMonth.year) {
            index = getMonth(this.start) + 1;
          }
          if (currentYear == endMonth.year) {
            currentMonth = endMonth.month;
          }
        }
        for (let i = index; i <= currentMonth; i++) {
          if (i < 10) {
            arr.push("0" + i);
          }
          else {
            arr.push(i.toString());
          }
        }
        this.monthList = arr
      },
      //初始化列表
      initList() {
        this.tempDataList = [];
        let day = [];
        let hour = [];
        for (let item of this.tempYearList) {
          day.push(item.year + "年")
        }
        for (let item of this.monthList) {
          hour.push(item + '月')
        }
        this.tempDataList[0] = day;
        this.tempDataList[1] = hour;
        this.$refs.startPicker.show();
      },
      //初始化时间
      initTimeValue() {
        if (this.tempCurTime) {
          let year = setYYYY(this.tempCurTime);
          let month = getMonth(this.tempCurTime) + 1;
          for (let i = 0; i < this.tempYearList.length; i++) {
            if (this.tempYearList[i].year == year) {
              this.curStartValue[0] = i;
            }
          }
          for (let i = 0; i < this.monthList.length; i++) {
            if (this.monthList[i] == month) {
              this.curStartValue[1] = i;
            }
          }
        }
        else {
          this.curStartValue[0] = this.tempYearList.length - 1;
          this.curStartValue[1] = this.monthList.length - 1;
        }
        this.setTimeData(this.curStartValue)
      },
      //时间更改事件
      onChange(data) {
        if (setYYYY(this.tempCurTime) != this.tempYearList[data[0]].year) {
          data[1] = 0;
        }
        this.setTimeData(data);
      },
      //设置时间
      setTimeData(value) {
        this.curStartValue = value;
        this.initMonth();
        this.tempCurTime = this.tempYearList[value[0]].year + "-" + this.monthList[value[1]] + "-01 00:00:00";
        this.initList()
      },
      //确认时间
      confirm() {
        this.onConfirm(this.tempCurTime);
        this.setTimeBox(0);
      },
      //设置组件
      setTimeBox(isShow) {
        if (isShow) {
          this.initTimeValue();
        }
        else {
          this.onCancel();
          this.timeType = 0
        }
      },
    },
  }
</script>
<style lang="scss" scoped type="text/scss">
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #000;
    opacity: 0.6;
    z-index: 10;
  }

  .page {
    position: fixed;
    left: 0;
    z-index: 11;
    width: 100%;
    background-color: #fff;
    transition: all 0.4s ease;
    &.tabBar {
      bottom: 110px !important;
    }
    &.hide {
      opacity: 0;
      bottom: -700px;
    }
    &.on {
      opacity: 1;
      bottom: 0;
    }
    .btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: solid 1px #ececec;
      .btn {
        padding: 30px;
        font-size: 30px;
        color: #027FFF;
      }
    }
    .navs {
      display: flex;
      align-items: center;
      .nav {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        box-sizing: border-box;
        flex: 1;
        color: rgba(0, 0, 0, .87);
        background-color: #ececec;
        &.on {
          color: #fff;
          background-color: #ff6e21;
        }
        .cont {
          margin-top: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/datetimeMini/datetime.vue